import React, { FC } from 'react';
import { ExpandableRow } from './expandableRow';
import { Row, RowProps, StyledRowProps } from './table';

interface ExpandableRowProps {
    content: React.ReactNode;
    isExpandable: boolean;
    useTextButton?: boolean;
    textOnClosed?: string;
    textOnOpen?: string;
    normalRowsComponentIfNotExpandable?: React.ReactNode;
    extraComponent?: React.ReactNode;
    onExpand?: (isExpanded: boolean) => void;
}

export const ExpandableOrNormalRow: FC<RowProps & StyledRowProps & ExpandableRowProps> = (props) => {
    const normalRowCells = [...props.cells, !props.isExpandable && props.normalRowsComponentIfNotExpandable && props.normalRowsComponentIfNotExpandable];
    return (
        <>
            {(props.isExpandable && (
                <ExpandableRow
                    cells={props.cells}
                    useTextButton={props.useTextButton}
                    textOnClosed={props.textOnClosed}
                    textOnOpen={props.textOnOpen}
                    content={props.content}
                    extraComponent={props.extraComponent}
                    onExpand={props.onExpand}
                ></ExpandableRow>
            )) || <Row {...props} cells={normalRowCells} />}
        </>
    );
};
